<!-- 维权查询页面 -->
<template>
  <div class="queryRight">
    <div class="nav-top">
      <i class="iconfont icon-zglsfanhui" @click="toIndex()"></i>
      {{ queryStr }}查询
    </div>
    <div class="detail-content">
      <div class="protection-search">
        <input
          type="text"
          :placeholder="'请输入' + queryStr + '登记编号'"
          v-model="number"
        />
        <button @click="queryCIMInfo()">查询</button>
      </div>
      <div class="application-title" v-if="info || showNodata">
        <img src="../assets/images/rect.png" alt="" />
        查询结果
      </div>
      <table
        class="protection-result-table"
        width="100%"
        cellspacing="0px"
        v-if="info"
      >
        <tr>
          <td class="tdborder label">{{ queryStr }}登记编号</td>
          <td class="tdborder value">{{ info.number }}</td>
        </tr>
        <tr>
          <td class="tdborder label">{{ queryStr }}处理</td>
          <td class="tdborder value">{{ info.status }}</td>
        </tr>
        <tr>
          <td class="tdborder label">{{ queryStr }}时间</td>
          <td class="tdborder value">{{ info.date }}</td>
        </tr>
      </table>
      <div class="protection-nodata" v-if="showNodata">
        <img src="../assets/images/nodata.png" alt="" />
        <p>未查询到该{{ queryStr }}案件信息</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../api/index";
export default {
  data() {
    return {
      number: "",
      queryStr: "",
      code: "",
      codeUrl: "/captchacircle",
      info: null,
      showNodata: false,
    };
  },
  created() {
    if (this.$route.params) {
      this.type = localStorage.getItem("rightType");
      this.queryStr = this.type === "RPM" ? "维权" : "投诉";
    }
  },
  methods: {
    queryCIMInfo() {
      this.info= null
      this.showNodata= false
      let params = {
        number: this.number,
        type: this.type,
      };
      api.queryCIMInfo(params).then((res) => {
        if (res.data.code === 1) {
          let info = {};
          if (this.type === "CIM") {
            let { complainNumber, issueStatus, complainDate } = res.data.result;
            info.number = complainNumber;
            info.status = issueStatus;
            info.date = complainDate;
          } else {
            let { rightsProtectionNumber, issueStatus, infringementDate } = res.data.result;
            info.number = rightsProtectionNumber;
            info.status = issueStatus;
            info.date = infringementDate;
          }
          this.info = info;
          this.showNodata = false;
        } else {
          this.showNodata = true;
        }
      });
    },
    toIndex() {
      this.$router.push({
        name: this.type === "RPM" ? "rightProtection" : "complainView",
      });
    },
    refreshCode() {
      this.codeUrl += "?v=" + new Date().getTime();
      this.code = "";
    },
  },
};
</script>
<style lang='scss' scoped>
.queryRight {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f4f6fa;
  .nav-top {
    position: relative;
    width: 100%;
    height: 2.75rem;
    background: #fff;
    text-align: center;
    font-weight: 600;
    font-size: 1.06rem;
    color: #323233;
    line-height: 2.75rem;
    .iconfont {
      position: absolute;
      left: 1rem;
      top: 0;
      font-size: 1.25rem;
      color: #323233;
    }
  }
  .input-box {
    width: 100%;
    height: 3rem;
    background: #fafafa;
    border-radius: 4px 0px 0px 4px;
    &-input {
      width: 15.94rem;
      height: 100%;
    }
    button {
      width: 5.5rem;
      height: 100%;
      background: #2163e0;
      border-radius: 0rem 0.25rem 0.25rem 0rem;
    }
  }
  .detail-content {
    margin-top: 0.63rem;
    width: 100%;
    height: calc(100% - 2.75rem);
    padding: 1.56rem 1rem;
    box-sizing: border-box;
    background: #fff;
    overflow: auto;
    .protection-search {
      width: 100%;
      height: 3rem;
    }

    .protection-search > input {
      width: 15.94rem;
      height: 3rem;
      padding-left: 1.31rem;
      box-sizing: border-box;
      background: #fafafa;
      border-radius: 0.25rem 0rem 0rem 0.25rem;
      overflow-wrap: break-word;
      outline: none;
      font-weight: 400;
      font-size: 1rem;
      color: rgba(0, 0, 0, 0.85);
      line-height: 1rem;
      white-space: nowrap;
    }

    .protection-search > button {
      width: 5.5rem;
      height: 3rem;
      background: #2163e0;
      border-radius: 0rem 0.25rem 0.25rem 0rem;
      border: 0;
      margin: 0 0 0 -0.25rem;
      font-weight: 400;
      font-size: 1rem;
      color: #ffffff;
      line-height: 1rem;
      white-space: nowrap;
    }

    .protection-nodata {
      margin: 0 auto;
      margin-top: 7.8rem;
      text-align: center;
      font-size: 1rem;
      font-family: sourcefont-Regular, sans-serif;
      font-weight: 400;
      color: #666666;
      line-height: 1rem;
    }

    .protection-nodata > img {
      margin-bottom: 1.25rem;
      width: 132px;
      height: 86px;
    }
    .application-title {
      width: 100%;
      height: 3rem;
      font-weight: 500;
      font-size: 1rem;
      color: rgba(0, 0, 0, 0.85);
      line-height: 3rem;
      img {
        margin-right: 0.44rem;
        width: 0.38rem;
        height: 0.81rem;
      }
    }
    .code-box {
      position: relative;
      margin-top: 1rem;
      font-weight: 500;
      font-size: 0.88rem;
      color: #171819;
      .el-input {
        margin-right: 4px;
        width: 30%;
      }
      img {
        position: absolute;
        top: 0;
        right: 4.4rem;
        width: 30%;
        height: 100%;
      }
      span {
        position: absolute;
        top: 8px;
        right: 0;
        font-size: 14px;
        color: #f27f02;
      }
    }
  }
}
.acla-new-right {
  margin-top: 0.75rem;
  border-top: 2px solid #0057d7;
  width: 100%;
  height: calc(100% - 2.75rem);
  overflow: auto;
  padding: 0 24px 56px 24px;
  box-sizing: border-box;
}

.acla-new-right-title {
  margin-bottom: 24px;
  border-bottom: 1px solid #d6e7ff;
  height: 64px;
  font-size: 24px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: bold;
  color: #0057d7;
  line-height: 64px;
}

.acla-new-right-content {
  margin: 0 8px;
  font-size: 18px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  line-height: 26px;
}

.acla-new-left-title {
  width: 100%;
  height: 64px;
  text-align: center;
  font-size: 20px;
  font-family: SourceHanSerifCN, SourceHanSerifCN;
  font-weight: 800;
  color: #ffffff;
  line-height: 64px;
  // background-image: url(./image/introduction.png);
  background-size: cover;
}

.acla-new-left-item {
  position: relative;
  border: 1px solid #f0f0f0;
  border-top: 0;
  height: 48px;
  padding-left: 24px;
  font-size: 16px;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 400;
  color: #666666;
  line-height: 48px;
  cursor: pointer;
}

.acla-new-left-item:hover .acla-new-left-item-name {
  color: #0057d7;
}

.icon-commright1 {
  position: absolute;
  top: 0;
  right: 32px;
  display: none;
  font-size: 12px;
}

.acla-new-left-item-active {
  font-weight: 500;
  background: linear-gradient(90deg, #d3e5ff 0%, #f8fbff 100%);
  color: #0057d7;
}

.protection-result-title {
  margin-bottom: 1.5rem;
  border-left: 0.25rem solid #0057d7;
  height: 1.625rem;
  padding-left: 1rem;
  font-size: 1rem;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 500;
  color: #333333;
  line-height: 1.625rem;
}

.protection-result-table {
  border: 0.0625rem solid #d9d9d9;
  font-size: 0.875rem;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.65);
  line-height: 1rem;
}

.protection-result-table tr {
  height: 3.5rem;
}

.protection-result-table .tdborder {
  border-bottom: 0.0625rem solid #d9d9d9;
  border-right: 0.0625rem solid #d9d9d9;
}

.protection-result-table .lasttdborder {
  border-right: 0;
}

.protection-result-table .label {
  width: 7.5rem;
  text-align: center;
  font-size: 0.875rem;
  font-family: SourceHanSansCN, SourceHanSansCN;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1rem;
  background-color: #f7faff;
}

.protection-result-table .value {
  width: 20.0625rem;
  padding: 1.25rem;
  box-sizing: border-box;
}

.protection-result-table a {
  color: #0057d7;
}
</style>